<app-breadcrumb [master]="'Administracja'" [parentName]="'Hiperio'" [name]="'Profile'"></app-breadcrumb>
<div class="users-job-list-container" >
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="users-job-list-filters">
    <app-dict-partners
      [multiple]="false" [label]="'Partner'"
      class="users-job-list-filter"
      [(ngModel)]="initialFilters.partner" name="partner"
    ></app-dict-partners>

    <app-dict-ofwcas
      [multiple]="false" label="OFWCA"
      class="users-job-list-filter "
      [(ngModel)]="initialFilters.ofwca" name="ofwca"
    ></app-dict-ofwcas>


    <app-datepicker
      class="users-job-list-filter"
      label="Data utworzenia od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
    ></app-datepicker>

    <app-datepicker
      class="users-job-list-filter"
      label="Data utworzenia do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
    ></app-datepicker>

    <app-dict
      [multiple]="false" [dictType]="'hiperio_user_job_status'"
      [label]="'Status'" class="users-job-list-filter"
      [(ngModel)]="initialFilters.status" name="status"
    ></app-dict>

    <app-dict-regionals
      [multiple]="false" label="Regionalny (majątek)"
      class="users-job-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <mat-form-field appearance="standard" class="users-job-list-filter">
      <mat-label>Konto utworzone</mat-label>
      <mat-select [(ngModel)]="initialFilters.accountCreated" name="accountCreated">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div class="users-job-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
    <table mat-table [dataSource]="jobs" >

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
        <td mat-cell *matCellDef="let element">
          {{element.createdAt | date:'y-MM-dd HH:mm'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.createdBy">
            <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
          </ng-container>
          <ng-container *ngIf="!element.createdBy">
            System
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="ofwca">
        <th mat-header-cell *matHeaderCellDef> OFWCA </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.ofwca">
            <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
          </ng-container>
        </td>
      </ng-container>


      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'" [matTooltip]=element.output>
            {{element.status.name}}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAccount">
        <th mat-header-cell *matHeaderCellDef> Konto utworzone </th>
        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle
            [disabled]="!(userPermissions | async)?.hiperio.write || updateInProgress"
            [checked]="element.accountCreated" (change)="formChanged(
            $event,
            element,
            {accountCreated: !element.accountCreated}
        )"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf=" element.status?.key!== HIPERIO_USER_JOB_STATUS_CREATED  && (userPermissions | async).hiperio?.write " (click)="restart(element.uuid)" mat-stroked-button  color="warn">Odśwież status</button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>

</div>
